import React from "react";
import { Link } from "react-router-dom";

function CallToAction() {
  return (
    <div className="bg-[#222831] py-12 px-6 flex flex-col items-center text-center mt-12">
      <h1 className="text-4xl font-bold text-white mb-6">
        🚀 Take Your Coding to the Next Level!
      </h1>
      <p className="text-gray-300 max-w-2xl mb-8">
        Join thousands of developers improving their DSA skills daily. Stay consistent, 
        track your progress, and build real-world expertise with Unito.
      </p>
      <Link to="/register">
      <button className="px-6 py-3 text-lg font-semibold rounded-lg 
                         bg-gradient-to-r from-violet-500 to-red-500 
                         text-white shadow-md hover:scale-105 transition-all duration-300">
        Get Started for Free
      </button>
      </Link>
    </div>
  );
}

export default CallToAction;
